import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../../../shared/shared.module';
import { EditBookingComponent } from './edit-booking.component';
import { EditBookingRoutingModule } from './edit-booking-routing.module';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';
import { EditBookingResolve } from './edit-booking.resolve';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    AppMaterialModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    SharedModule,
    EditBookingRoutingModule,
    MatDialogModule,
  ],
  declarations: [EditBookingComponent],
  entryComponents: [],
  exports: [EditBookingComponent],
  providers: [EditBookingResolve],
})
export class EditBookingModule {}
